import React from 'react';
import { Container, Typography, Box, Divider, Link } from '@mui/material';
import { images } from '../../../../../shared/lib/assets';

export const TermsAndConditions = () => (
  <Container maxWidth="md" sx={{ py: 5 }}>
    {/* Title */}
    <Box display="flex" justifyContent="center" mb={4}>
      <Link href="https://855whodoicall.com" target="_blank" underline="none">
        <Box component="img" src={images.DASHBOARD_LOGO as unknown as string} alt="855WhoDoICall.com" sx={{ height: 60 }} />
      </Link>
    </Box>

    <Typography variant="h4" align="center" fontWeight="700" gutterBottom>
      Terms and Conditions
    </Typography>

    <Typography variant="h6" align="center" sx={{ mb: 2, fontWeight: 600 }}>
      855WHODOICALL® TERMS OF USE AGREEMENT (Effective September 1, 2018).
    </Typography>

    {/* Intro */}
    <Box mb={4}>
      <Typography variant="body1" paragraph>
        Welcome to 855WHODOICALL®, operated by FALLBACK SERVICESTM, LLC, located at 2501 Thornapple River Dr. Grand Rapids Michigan 49546 (“855WHODOICALL®,” “we,” “us,” or “our”).
      </Typography>
      <Typography variant="body1" paragraph>
        By using the 855WHODOICALL® website located at www.WHODOICALL®.com, the mobile website, the mobile application called 855WHODOICALL®, and/or calling or accessing the telephonic service numbers
        utilized by 855WHODOICALL® (collectively, the “Service”), you agree to be bound by these Terms of Use (this “Terms of Use” or “Agreement”), whether or not you register as a member of
        855WHODOICALL® (“Member”). If you wish to become a Member and/or make use of the Service, please read this Agreement. If you object to anything in this Agreement or the 855WHODOICALL® Privacy
        Policy, do not use the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® provides a telephonic platform for Members to access specific persons designated by the Member (individually a “Contact” and collectively “Contacts”) via calling the
        855WHODOICALL® main access telephone number (a “Call In”) for the purpose of attempting to communicate with one or more of the Member’s Contacts for situations in which the Member does not
        know or recall a Contact’s telephone number(s).
      </Typography>
      <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
        PLEASE READ THIS AGREEMENT CAREFULLY AS IT CONTAINS IMPORTANT INFORMATION REGARDING YOUR LEGAL RIGHTS, REMEDIES AND OBLIGATIONS, INCLUDING VARIOUS LIMITATIONS AND EXCLUSIONS, AND A DISPUTE
        RESOLUTION CLAUSE THAT GOVERNS HOW DISPUTES WILL BE RESOLVED.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 1 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        1) Electronic Agreement
      </Typography>
      <Typography variant="body1" paragraph>
        This Terms of Use is an electronic contract that sets out the legally binding terms of your use of the Service. This Terms of Use is subject to change by 855WHODOICALL® at any time, effective
        upon posting on the 855WHODOICALL® Service or by emailing you at the email address associated with your account. By accessing and/or using the Service or becoming a Member, you accept this
        Terms of Use and agree to the terms, conditions and notices contained or referenced herein. Your continued use of the Service following 855WHODOICALL®’s posting of, or sending to your email
        address, revised terms of any section of the Terms of Use will constitute your express and binding acceptance of and consent to the revised Terms of Use.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 2 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        2) Access and Retention
      </Typography>
      <Typography variant="body1" paragraph>
        In order to access and retain this electronic Agreement, you must have access to the World Wide Web, either directly or through devices that access web-based content, and pay any service fees
        associated with such access. In addition, you must use all equipment necessary to make such connection to the World Wide Web, including a computer and modem or other access device. Please
        print a copy of this Agreement for your records. To retain an electronic copy of this Agreement, you may save it into any word processing program.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 3 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        3) Eligibility
      </Typography>
      <Typography variant="body1" paragraph>
        You must be at least eighteen (18) years of age. By using the Service, you represent and warrant that you have the right, authority and capacity to enter into this Agreement and to abide by
        all of the terms and conditions of this Agreement. The Service is also not available to any users who have been previously removed or suspended from the Service.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 4 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        4) Commercial Use of Service Restrictions
      </Typography>
      <Typography variant="body1" paragraph>
        Illegal and/or unauthorized uses of the Service include, but are not limited to, collecting information of Members or Contacts by electronic or other means for the purpose of unwanted
        communication, unauthorized framing of or linking to the Service, sharing or disclosing your email address or password to any third party or permitting any third party to access your account,
        attempting to impersonate another user or person, use of the Service in any fraudulent or misleading manner, any automated use of the system, such as scraping the Service, automated scripts,
        spiders, robots, crawlers, harvesting or data mining tools or the like, interfering with, disrupting, or creating an undue burden on the Service or the networks or services connected to the
        Service, and using the Service in a manner inconsistent with any and all applicable laws and regulations. Illegal and/or unauthorized use of the Service may be investigated, and appropriate
        legal action may be taken, including without limitation, civil, criminal, and injunctive redress. Use of the Service is with the permission of 855WHODOICALL®, which may be revoked at any time,
        for any reason, in 855WHODOICALL®’s sole discretion.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 5 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        5) Account Security
      </Typography>
      <Typography variant="body1" paragraph>
        You are responsible for maintaining the confidentiality of the username and password that you designate during the registration process, and you are fully responsible for all activities that
        occur under your username and password. You agree to immediately notify 855WHODOICALL® of any unauthorized use of your username or password or any other breach of security. 855WHODOICALL® will
        not be liable for any loss or damage arising from your failure to comply with this provision. You should use particular caution when accessing your account from a public or shared device or
        internet so that others are not able to view or record your password or other personal information. If you share your computer with others, you may wish to consider disabling your auto-sign in
        feature if you have it linked to your 855WHODOICALL® account.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 6 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        6) Your Use of the Service
      </Typography>
      <Typography variant="body1" paragraph>
        By using the Service you acknowledge and agree:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>that you will not act in a way which violates any provisions of these Terms of Use;</li>
          <li>that you will reasonably cooperate with 855WHODOICALL® in the event that 855WHODOICALL® needs to verify your compliance with the above, or otherwise with these Terms of Use;</li>
          <li>that you are solely responsible for your disclosure of Contact information;</li>
          <li>that 855WHODOICALL® is not responsible for any Service disruption caused by any Third Party vendors or service providers; and</li>
          <li>
            that your caller identification sent to a Contact during use of the Service will/may display to the Contact as from you and/or with your telephone number, and not as a call from
            855WHODOICALL®.
          </li>
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        You must not copy or capture, or attempt to copy or capture, any content from the Service, unless given express permission by 855WHODOICALL®.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not copy, republish, adapt, make available or otherwise communicate to the public, display, perform, transfer, share, distribute or otherwise use or exploit any content on or from the
        Service.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not use any content in any way that is designed to create a separate service or that replicates any part of the offering of the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not employ scraping or similar techniques to aggregate, repurpose, republish or otherwise make use of any content.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not employ any techniques or make use of any services, automated or otherwise, designed to misrepresent your activity on the Service, including without limitation by the use of bots,
        botnets, scripts, apps, plugins, extensions or other automated means to register accounts, log in, send messages, post comments, or otherwise to act on your behalf, particularly where such
        activity occurs in a multiple or repetitive fashion.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not offer or promote the availability of any such techniques or services to any other users of the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not alter or remove, or attempt to alter or remove, any trademark, copyright or other proprietary or legal notices contained in, or appearing on, the Service, whether registered or
        unregistered, or any content appearing on the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not, and must not permit any third party to, copy or adapt the object code of the Service, or reverse engineer, reverse assemble, decompile, modify or attempt to discover any source
        or object code of any part of the Service, or circumvent or attempt to circumvent or copy any copy protection mechanism or access any rights management information pertaining to content on the
        Service.
      </Typography>
      <Typography variant="body1" paragraph>
        You must not use the Service to upload, post, store, transmit, display, copy, distribute, promote, make available or otherwise communicate to the public, including Contacts:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>
            any content that is offensive, abusive, libelous, defamatory, obscene, racist, sexually explicit, ethnically or culturally offensive, indecent, that promotes violence, terrorism, or
            illegal acts, incites hatred on grounds of race, gender, religion or sexual orientation, or is otherwise objectionable in 855WHODOICALL®’s sole and reasonable discretion;
          </li>
          <li>
            any information, content or other material that violates, plagiarizes, misappropriates or infringes the rights of third parties including, without limitation, copyright, trademark rights,
            rights of privacy or publicity, confidential information or any other right;
          </li>
          <li>any content that violates, breaches or is contrary to any law, rule, regulation, court order or is otherwise is illegal or unlawful in 855WHODOICALL®’s sole and reasonable opinion;</li>
          <li>
            any material of any kind that contains any virus, Trojan horse, spyware, adware, malware, bot, time bomb, worm, or other harmful or malicious component, which will or might overburden,
            impair or disrupt the Service or servers or networks forming part of, or connected to, the Service, or which does or might restrict or inhibit any other user’s use and enjoyment of the
            Service; or
          </li>
          <li>any unsolicited or unauthorized advertising, promotional messages, spam or any other form of solicitation.</li>
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        1. You must not commit or engage in, or encourage, induce, solicit or promote, any conduct that would constitute a criminal offense, give rise to civil liability or otherwise violate any law
        or regulation.
      </Typography>
      <Typography variant="body1" paragraph>
        2. You must not rent, sell or lease access to the Service, or any content on the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        3. You must not deliberately impersonate any person or entity or otherwise misrepresent your affiliation with a person or entity, for example, by registering an account in the name of another
        person or company, or sending messages or making comments using the name of another person.
      </Typography>
      <Typography variant="body1" paragraph>
        4. You must not stalk, exploit, threaten, abuse or otherwise harass another user, a Contact, or any 855WHODOICALL® employee. If 855WHODOICALL® determines that any user has threatened, stalked,
        harassed, or verbally abused any 855WHODOICALL® employee or another 855WHODOICALL® Member or a Contact, 855WHODOICALL® reserves the right to immediately terminate that user’s membership and
        suspend access to the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        5. You must not sell or transfer, or offer to sell or transfer, any 855WHODOICALL® account to any third party without the prior written approval of 855WHODOICALL®.
      </Typography>
      <Typography variant="body1" paragraph>
        6. You must not collect or attempt to collect personal data, or any other kind of information about other users, including without limitation, through spidering or any form of scraping.
      </Typography>
      <Typography variant="body1" paragraph>
        7. You must not violate, circumvent or attempt to violate or circumvent any data security measures employed by 855WHODOICALL®; access or attempt to access data or materials which are not
        intended for your use; log into, or attempt to log into, a server or account which you are not authorized to access; attempt to scan or test the vulnerability of 855WHODOICALL®’s servers,
        system or network or attempt to breach 855WHODOICALL®’s data security or authentication procedures; attempt to interfere with the Service by any means including, without limitation, hacking
        855WHODOICALL®’s servers or systems, submitting a virus, overloading, mail-bombing robo-calling or crashing. Without limitation to any other rights or remedies of 855WHODOICALL® under these
        Terms of Use, 855WHODOICALL® reserves the right to investigate any situation that appears to involve any of the above, and may report such matters to, and cooperate with, appropriate law
        enforcement authorities in prosecuting any users who have participated in any such violations.
      </Typography>
      <Typography variant="body1" paragraph>
        You agree to comply with the above conditions, and acknowledge and agree that 855WHODOICALL® has the right, in its sole discretion, to terminate your account or take such other action,
        including all available remedies at law, as we see fit if you breach any of the above conditions or any of the other terms of these Terms of Use. This may include taking court action and/or
        reporting offending users to the relevant authorities.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 7 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        7) 855WHODOICALL® is a Marketplace
      </Typography>
      <Typography variant="body1" paragraph>
        You acknowledge and agree that 855WHODOICALL® does not provide emergency services.
      </Typography>
      <Typography variant="body1" paragraph>
        You acknowledge and agree that 855WHODOICALL® does not have control over the quality, safety, morality or legality of any aspect of any Member or Contact, or the truth or accuracy of any
        Member or Contact statements. 855WHODOICALL® cannot ensure that a Contact will actually answer, respond or take any type of action at all.
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® does not guarantee the true identity, age, and nationality of a Member or Contact.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 8 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        8) Membership, Pricing, Charges on Your Account.
      </Typography>
      <Typography variant="body1" paragraph>
        1. <strong>General.</strong> Please note that the billing policies that are disclosed to you in subscribing to the Service are deemed part of this Terms of Use. Notwithstanding anything
        herein, you are solely responsible for all taxes associated with your use of the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        b. <strong>Billing.</strong> WHODOICALL® bills you through an online account (your “Billing Account”) for use of the Service. You agree to pay to 855WHODOICALL® all charges at the prices then
        in effect for any use of the Service by you or other persons (including your agents) using your Billing Account, and you authorize 855WHODOICALL® to charge your chosen payment provider (your
        “Payment Method”) for the Service. You agree to make all payments using that selected Payment Method. 855WHODOICALL® reserves the right to correct any errors or mistakes that it makes even if
        it has already requested or received payment.
      </Typography>
      <Typography variant="body1" paragraph>
        c. <strong>Payment Method.</strong> The terms of your payment will be based on your Payment Method and may be determined by agreements between you and the financial institution, credit card
        issuer, or other provider of your chosen Payment Method.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 9 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        9) Payments and Credits
      </Typography>
      <Typography variant="body1" paragraph>
        1. <strong>Calculation of Payment.</strong> Members will be charged as follows:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>a fixed monthly payment of $3.00, or annual payment of $19.00, depending upon the plan to which you subscribe, for access to the Service (referred to as a “Membership Fee”); and</li>
          <li>a minimum charge of up to fifty cents ($0.50 USD) per minute, or for each fraction thereof, for any and all phone calls in access of the Service (referred to as a “Use Fee”).</li>
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® may change Membership or Use Fees at any time in its sole discretion, in which case we will update the amounts displayed on the Service.
      </Typography>
      <Typography variant="body1" paragraph>
        2. <strong>Promotional Credits.</strong> 855WHODOICALL® may, from time to time and in its sole discretion, offer promotional credits for the Service. Any such promotional credits may be
        applied to subsequent Membership or Use Fees, but may not be transferred or sold.
      </Typography>
      <Typography variant="body1" paragraph>
        3. <strong>Method of Payments.</strong> Members acknowledge and agree that their Payment Method for any Membership or Use Fees must be either credit or debit card. No Service will be provided
        if a Member’s Payment Method is declined or expired. You expressly authorize 855WHODOICALL® to charge any credit or debit cards on file for all changes incurred, including automatic renewal
        charges.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 10 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        10) Modifications to Service
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® reserves the right at any time to modify or discontinue, temporarily or permanently, the Service (or any part thereof) with or without notice. You agree that 855WHODOICALL®
        shall not be liable to you or to any third party for any modification, suspension or discontinuance of the Service.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 11 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        11) Blocking of IP Addresses
      </Typography>
      <Typography variant="body1" paragraph>
        In order to protect the integrity of the Service, 855WHODOICALL® reserves the right at any time in its sole discretion to block Members from certain IP addresses or telephone numbers from
        accessing the Service.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 12 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        12) Term
      </Typography>
      <Typography variant="body1" paragraph>
        This Terms of Use will remain in full force and effect while you use the Service. You may terminate your membership at any time by deactivating your account in the user console or by emailing
        us at customerservice@WHODOICALL.com. If you resign or cancel your membership to 855WHODOICALL®, to help 855WHODOICALL® analyze and improve the Service, you may be asked to provide a reason
        for your resignation/cancellation.
      </Typography>
      <Typography variant="body1" paragraph>
        Your membership will automatically renew for successive terms (e.g., a monthly membership will renew for another month, an annual membership will renew for another year) unless and until you
        terminate the membership.
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® may terminate your membership for any reason by sending notice to you at the email address you provide in your application for membership, or such other email address as you may
        later provide to 855WHODOICALL®. All decisions regarding the termination of accounts shall be made in the sole discretion of 855WHODOICALL®. 855WHODOICALL® is not required to provide you
        notice prior to terminating your membership. 855WHODOICALL® is not required, and may be prohibited, from disclosing a reason for the termination of your account.
      </Typography>
      <Typography variant="body1" paragraph>
        Even after your membership is terminated, this Terms of Use will remain in effect. All terms that by their nature may survive termination of this Terms of Use shall be deemed to survive such
        termination.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 13 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        13) Third-Party Content
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® may provide third-party content on the Service and may provide links to webpages and content of third parties (collectively, the “Third-Party Content”) as a service to those
        interested in this information. 855WHODOICALL® does not control, endorse, or adopt any Third-Party Content and makes no representation or warranties of any kind regarding the Third-Party
        Content, including without limitation regarding its accuracy or completeness. Please be aware that 855WHODOICALL® does not create Third-Party Content, nor does 855WHODOICALL® update or monitor
        it. 855WHODOICALL® is therefore not responsible for any Third-Party Content on the Service. Users use such Third-Party Content at their own risk.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 14 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        14) Intellectual Property
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL®, the 855WHODOICALL® logos, and any other product or service name or slogan contained in the Service are trademarks of 855WHODOICALL® or our suppliers or licensors and may not be
        copied, imitated, or used, in whole or in part, without the prior written permission of 855WHODOICALL® or the applicable trademark holder. Any authorized use of these trademarks must be in
        accordance with any guidelines that 855WHODOICALL® may provide you from time to time.
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® retains all proprietary rights in the Service, except where otherwise noted. The Service contains the copyrighted material, trademarks, and other proprietary information of
        855WHODOICALL®, and its licensors. Except where we have given you express written permission, you may not copy, modify, publish, transmit, distribute, perform, display, or sell any such
        proprietary information. All content on 855WHODOICALL® is proprietary. Except where otherwise specified in this Agreement, all content of the Services is copyrighted material of 855WHODOICALL®
        and for 855WHODOICALL® Members’ use only. Distribution of such content to others is strictly prohibited. You agree that 855WHODOICALL® would be irreparably harmed by any violation or
        threatened violation of this section and that, therefore, 855WHODOICALL® shall be entitled to an injunction prohibiting you from any violation or threatened violation of this section, without
        posting bond, in addition to any other right or remedy it may have.
      </Typography>
      <Typography variant="body1" paragraph>
        You may not use any metatags or any other hidden text utilizing “WHODOICALL®” or any other name, trademark, or product or service name of 855WHODOICALL® without our prior written permission.
        In addition, the look and feel of the 855WHODOICALL® Service, including all page headers, custom graphics, button icons, and scripts, is the service mark, trademark, and/or trade dress of
        855WHODOICALL® and may not be copied, imitated, or used, in whole or in part, without our prior written permission. All other trademarks, registered trademarks, product names, and company
        names or logos mentioned in the Service are the property of their respective owners. Reference to any products, services, processes, or other information, by trade name, trademark,
        manufacturer, supplier, or otherwise does not constitute or imply endorsement, sponsorship, or recommendation thereof by us or any other affiliation.
      </Typography>
      <Typography variant="body1" paragraph>
        The Service is owned and operated by 855WHODOICALL®. Unless otherwise indicated, all content and other materials on the Service, including, without limitation, 855WHODOICALL®’s logos, the
        visual interfaces, graphics, design, compilation, information, software, computer code (including source code or object code), services, text, pictures, information, data, sound files, other
        files, and the selection and arrangement thereof (collectively, the “Materials”) are protected by United States of America copyright, trade dress, patent, and trademark laws, international conventions,
        and all other relevant intellectual property and proprietary rights, and applicable laws (including in your country of residence).
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 15 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        15) Reporting Claims of Copyright Infringement
      </Typography>
      <Typography variant="body1" paragraph>
        We take claims of copyright infringement seriously. We will respond to notices of alleged copyright infringement that comply with applicable law. If you believe any materials accessible on or
        from the Service infringe on your copyright, you may request removal of those materials (or access to them) from the Service by submitting written notification to our copyright agent
        designated below, in accordance with the Online Copyright Infringement Liability Limitation Act of the Digital Millennium Copyright Act (17 U.S.C. § 512) (“DMCA”).
      </Typography>
      <Typography variant="body1" paragraph>
        Our designated copyright agent to receive DMCA Notices is:
      </Typography>
      <Typography variant="body1" paragraph>
        c/o Copyright Agent
        <br />
        2501 Thornapple River Dr.
        <br />
        Grand Rapids, MI 49546
        <br />
        contact@WHODOICALL.com
      </Typography>
      <Typography variant="body1" paragraph>
        If you fail to comply with all of the requirements of Section 512(c)(3) of the DMCA, your DMCA Notice may not be effective. Please be aware that if you knowingly and materially misrepresent
        that material or activity on the Service is infringing your copyright, you may be held liable for damages (including costs and attorneys’ fees) under Section 512(f) of the DMCA.
      </Typography>
      <Typography variant="body1" paragraph>
        The DMCA allows us to restore the removed content if the party filing the original DMCA Notice does not file a court action against you within ten (10) business days of receiving the copy of
        your Counter-Notice.
      </Typography>
      <Typography variant="body1" paragraph>
        It is our policy in appropriate circumstances to disable and/or terminate the accounts of users who are repeat infringers.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 16 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        16) Limitation of Liability
      </Typography>
      <Typography variant="body1" paragraph>
        In no event shall 855WHODOICALL® be liable for any damages whatsoever, whether direct, indirect, general, special, compensatory, consequential, and/or incidental, arising out of or relating to
        the Service, or use thereof. Nothing contained in the Service or in any written or oral communications from 855WHODOICALL® or its employees or agents shall be construed to make any promise,
        covenant, warranty, or guaranty, all of which are explicitly disclaimed hereby, contrary to the statements and disclaimers contained in this paragraph.
      </Typography>
      <Typography variant="body1" paragraph>
        The content and functionality on the Service, along with the services provided by employees of the Service, are offered “as is” without warranty of any kind, either express or implied,
        including, without limitation, implied warranties of merchantability, fitness for a particular purpose, title and non-infringement. 855WHODOICALL® makes no warranties, express or implied, as
        to the ownership, accuracy, completeness or adequacy of the Service’s content or that the functionality of the Service will be uninterrupted or error-free or free from virus or third party
        attack. You hereby acknowledge that your use of the Service is at your sole risk.
      </Typography>
      <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
        TO THE GREATEST EXTENT PERMITTED BY LAW, UNDER NO CIRCUMSTANCES SHALL 855WHODOICALL®, ITS OFFICERS, OWNERS, EMPLOYEES OR AGENTS AND THEIR RESPECTIVE HEIRS, SUCCESSORS AND ASSIGNS HAVE ANY
        LIABILITY, CONTINGENT OR OTHERWISE, FOR ANY DAMAGES, INCLUDING DIRECT, INCIDENTAL, PUNITIVE, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES THAT DIRECTLY OR INDIRECTLY RESULT FROM THE AGREEMENT
        OR THE USE OF, OR INABILITY TO USE, THE SERVICE OR THE INFORMATION CONTAINED THEREIN, INCLUDING WITHOUT LIMITATION FOR VIRUSES ALLEGED TO HAVE BEEN OBTAINED FROM THE SERVICE, LOST PROFITS,
        LOST DATA, LOSS OF GOODWILL, COPYRIGHT INFRINGEMENT, WORK STOPPAGE, EQUIPMENT FAILURE OR MALFUNCTION, PERSONAL INJURY, PROPERTY DAMAGE, OR ANY OTHER DAMAGES OR LOSSES, EVEN IF 855WHODOICALL®
        HAS BEEN NOTIFIED OF THE POSSIBILITY OF SUCH DAMAGES OR LOSSES AND REGARDLESS OF THE LEGAL OR EQUITABLE THEORY (CONTRACT, TORT, STATUTE, INDEMNITY OR OTHERWISE) UPON WHICH SUCH LIABILITY IS
        BASED.
      </Typography>
      <Typography variant="body1" paragraph>
        In the event that any of the foregoing limitations are deemed to be unenforceable, to the greatest extent permitted by law, you agree that the entire aggregate liability of 855WHODOICALL® and
        sole remedy available to any Member in any case in any way arising out of or relating to the Agreement or the Service shall be limited to monetary damages that in the aggregate may not exceed
        the greater of Five Hundred Dollars ($500.00) or the sum of any amount paid by the Member to 855WHODOICALL® during the six (6) months prior to notice to 855WHODOICALL® of the dispute for which
        the remedy is sought.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 17 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        17) Indemnity by You
      </Typography>
      <Typography variant="body1" paragraph>
        You agree to indemnify and hold 855WHODOICALL®, its subsidiaries, affiliates, officers, agents, and other partners and employees, harmless from and against any loss, liability, claim, or
        demand, including reasonable attorneys’ fees, arising out of or related to your use of (or inability to use) the Service, and any violation of this Terms of Use and/or arising from a breach of
        this Terms of Use including, without limitation, your representations and warranties set forth herein.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 18 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        18) Attorney Fees
      </Typography>
      <Typography variant="body1" paragraph>
        In the event that 855WHODOICALL® is successful in whole or in part in any action or proceeding related to or arising from this Terms of Use, you shall be responsible for 855WHODOICALL®’s
        attorneys’ fees and costs.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 19 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        19) No Persons Under the Age of 18
      </Typography>
      <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
        INDIVIDUALS UNDER THE AGE OF EIGHTEEN (18) ARE NOT PERMITTED TO USE THE SERVICE. INDIVIDUALS UNDER THE AGE OF EIGHTEEN (18) ARE NOT PERMITTED TO SUBSCRIBE TO OUR FEE-BASED SERVICE OR GIVE
        855WHODOICALL® THEIR EMAIL ADDRESS, TELEPHONE NUMBER OR ANY OTHER PERSONALLY IDENTIFIABLE INFORMATION.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 20 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        20) Privacy
      </Typography>
      <Typography variant="body1" paragraph>
        Use of the Service is also governed by our Privacy Policy.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 21 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        21) Jurisdiction and Choice of Law; Dispute Resolution
      </Typography>
      <Typography variant="body1" paragraph>
        If there is any dispute arising out of the Service, by using the Service, you expressly agree that any such dispute shall be governed by the laws of the State of Michigan, without regard to
        its conflict of law provisions, and you expressly agree and consent to the exclusive jurisdiction and venue of the state and federal courts of the State of Michigan, for the resolution of any
        such dispute. Acceptance of the terms and conditions of this Agreement constitutes your consent to be sued in such courts and to accept service of process outside the State of Michigan with
        the same force and effect as if such service had been made within the State of Michigan. You hereby agree to accept service of process for any action hereunder by certified mail return receipt
        requested which service shall have the same force and effect as though service had been effected by personal service in the applicable jurisdiction. If any part of these terms is unlawful,
        void, or unenforceable, that part will be deemed severable and will not affect the validity and enforceability of the remaining provisions.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 22 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        22) Arbitration Provision/No Class Action
      </Typography>
      <Typography variant="body1" paragraph>
        Except where prohibited by law, as a condition of using the Service, you agree that any and all disputes, claims and causes of action (collectively, “Claim”) arising out of or connected with
        the Service, shall be resolved individually, without resort to any form of class action, exclusively by binding arbitration for full and final settlement of such Claim, and judgment on the
        award rendered in the arbitration may be entered in any court having jurisdiction thereof. The parties shall agree upon the arbitrator (in the event an agreement cannot be reached, each party
        shall select an arbitrator, both of whom will select a third person to act as the sole arbitrator in this matter) and shall split in equal proportions the arbitration and/or mediator costs. An
        award rendered by the arbitrator(s) may be entered and confirmed by the courts of the State of Michigan, County of Kent, or the United States of America District Court for the Western District of
        Michigan. The parties agree that any post-arbitration action seeking to enforce an arbitration award or action seeking equitable or injunctive relief shall be brought exclusively in the courts
        of the State of Michigan, County of Kent, or the United States of America District Court for the Western District of Michigan.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 23 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        23) Personally Identifiable Information That We Collect:
      </Typography>
      <Typography variant="body1" paragraph>
        You may be required to submit certain personally identifiable information when you register for the Service. The personally identifiable information which you may provide to us could include
        your email, name, address, telephone number, birth date, gender, payment information, and other personal information.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 24 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        24) Choice of Use of App:
      </Typography>
      <Typography variant="body1" paragraph>
        Users may use the application as an additional toolset to manage their 855WHODOICALL.com account. 855WhoDoICall.com provides a trusted calling service that allows its users to place a call to
        855WhoDoICall (855) 946-3342 and through that call, they can place a call to any of their Trusted Contacts that they have saved within their VIP contact list.
      </Typography>
      <Typography variant="body1" paragraph>
        Managing their account includes but is not limited to the following:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Make calling plan changes</li>
          <li>Update Billing information</li>
          <li>Update Contact information</li>
          <li>Update Account Details</li>
          <li>Cancel Services and Delete their account</li>
          <li>Review Calling Logs</li>
          <li>Review Ring My Phone (RMP) logs</li>
          <li>Update/Customize the RMP messaging services</li>
        </ul>
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 25 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        25) Geo-Location Information:
      </Typography>
      <Typography variant="body1" paragraph>
        When you access or use the Service, 855WHODOICALL® may access, collect, monitor and/or remotely store “location data,” which may include GPS coordinates (including, but not limited to,
        latitude and/or longitude), IP addresses, and/or similar information regarding the actual location of your device. The Ring My Phone (RMP) technology may allow you to locate your device by
        viewing the location of the device in your Secure User Portal. Location data may also convey to us information about how you browse or use the Service. Location data that we collect internally
        does not contain any personally identifiable information about you. Location data may be used in conjunction with personally identifiable information to locate your device.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 26 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        26) Contact Opt-Out Process:
      </Typography>
      <Typography variant="body1" paragraph>
        Contacts added by users to their account have the ability to opt-out of being included in the contact list. If a contact wishes to be removed, they can:
      </Typography>
      <Typography variant="body1" component="div">
        <ul>
          <li>Follow the link provided by 855WHODOICALL® in the automated text and/or email sent by us and select “Opt-Out”</li>
          <li>Contact us directly at Opt-Out@855WHODOICALL.COM.</li>
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        Once an opt-out request is received, we will promptly remove the contact from the users contact list.
      </Typography>
      <Typography variant="body1" paragraph>
        To Opt-In again, the Contact must contact us directly by emailing us at Opt-In@855WHODOICALL.com requesting such, including the User Name and Phone Number for the user which they want to be
        added again as a contact.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 27 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        27) No Third Party Beneficiaries
      </Typography>
      <Typography variant="body1" paragraph>
        You agree that, except as otherwise expressly provided in this Terms of Use, there shall be no third party beneficiaries to this Terms of Use.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 28 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        28) Availability Outside the U.S.
      </Typography>
      <Typography variant="body1" paragraph>
        The 855WHODOICALL® sites are hosted in the United States of America. If you visit from the European Union or other foreign jurisdictions, please note that (a) we make no representations or warranties
        that the information, products or services contained on the 855WHODOICALL® sites is appropriate for use or access or is available in other jurisdictions and (b) these jurisdictions have laws
        governing data collection and use that may differ from United States of America law. If you access 855WHODOICALL® from outside of the United States of America, you do so at your own risk and are responsible for
        compliance with the laws of your jurisdiction. If you access the Service from outside of the United States of America, you acknowledge that any personal information you provide will be processed in the
        United States of America and other geographies as selected by us in our sole discretion, and you hereby consent to the collection and processing of your personal information in a manner consistent with
        this Agreement and the Privacy Policy.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 29 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        29) Entire Agreement
      </Typography>
      <Typography variant="body1" paragraph>
        This Terms of Use, along with the Privacy Policy, contains the entire agreement between you and 855WHODOICALL® regarding the use of the Service.
      </Typography>
      <Typography variant="body1" paragraph sx={{ fontWeight: 'bold' }}>
        IN THE EVENT OF ANY INCONSISTENCY OR CONFLICT BETWEEN THIS AGREEMENT AND THE 855WHODOICALL® PRIVACY POLICY, THE FOLLOWING ORDER OF PRECEDENCE SHALL CONTROL: (A) THIS AGREEMENT; AND (B) THE
        855WHODOICALL® PRIVACY POLICY.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 30 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        30) Severability Waiver
      </Typography>
      <Typography variant="body1" paragraph>
        If any provision of this Terms of Use is found to be invalid by any court having competent jurisdiction, the invalidity of such provision shall not affect the validity of the remaining
        provisions of this Terms of Use, which shall remain in full force and effect. No waiver of any term of this Terms of Use shall be deemed a further or continuing waiver of such term or any
        other term. In addition, 855WHODOICALL®’s failure to enforce any term of this Terms of Use shall not be deemed as a waiver of such term or otherwise affect 855WHODOICALL®’s ability to enforce
        such term at any point in the future.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 31 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        31) Headings
      </Typography>
      <Typography variant="body1" paragraph>
        The section headings contained in this Terms of Use are for reference purposes only and shall not in any way affect the meaning or interpretation of this Terms of Use.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    {/* Section 32 */}
    <Box mb={4}>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        32) Assignment
      </Typography>
      <Typography variant="body1" paragraph>
        You may not assign this Agreement or any of the rights contained herein, in whole or in part, to any third party without 855WHODOICALL®’s prior written consent.
      </Typography>
      <Typography variant="body1" paragraph>
        Please contact us with any questions regarding this Agreement. 855WHODOICALL® is a trademark of Fallback Services, LLC.
      </Typography>
      <Typography variant="body1" paragraph>
        855WHODOICALL® reserves all rights not expressly granted in these Terms of Use.
      </Typography>
    </Box>

    <Divider sx={{ my: 3 }} />

    <Typography variant="body2" color="text.secondary" align="center">
      FALLBACK SERVICESTM, LLC — 2501 Thornapple River Dr., Grand Rapids, MI 49546
    </Typography>
  </Container>
);
